<template>
  <div class="base-content">
    <div class="base-title">
      <img
        class="bc-logo"
        alt="logo"
        :src="require('@/assets/gov_bc_logo_horiz_pos.png')"
      />
      <h1>Tobacco and Fuel Tax Exemption System</h1>
    </div>
    <div class="container-fluid">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({})
export default class BaseRegistration extends Vue {}
</script>

<style lang="scss" scoped>
.base-content {
  height: 100%;
  display: flex;

  @media (max-width: 767px) {
    height: auto;
    display: block;
    width: 100%;
  }
}

.base-title {
  background-color: #f4f5f8;
  background-image: url(../../assets/landing_screen_illustration.png);
  background-repeat: no-repeat;
  background-position: bottom center;
  background-color: #f4f5f8;
  overflow: visible;
  white-space: nowrap;
  height: 100%;
  vertical-align: middle;
  margin: 0;
  padding: 64px 62px 0 86px;
  width: 572px;

  h1 {
    display: block;
    padding-top: 32px;
    font-size: 32px;
    font-weight: bold;
    line-height: 42px;
    color: var(--bc-primary-blue);
    letter-spacing: -0.64px;
    white-space: normal;
  }

  .bc-logo {
    height: 40px;
    object-fit: contain;
  }

  @media (min-width: 992px) {
    min-width: 572px;
  }

  @media (max-width: 992px) {
    background-image: none;
  }

  @media (max-height: 680px) {
    background-image: none;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 40px;
  }
}
</style>
